import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries';
import { APP_TEAM_NAME } from '@atlassian/jira-project-create-importer-common';
import { ImportModal } from './ui';
import type { Props } from './ui/types';

const APP_IDENTIFIER = 'jira-business.project-create-import-modal';

export const ImportProjectModal = (props: Props) => (
	<JSErrorBoundary
		teamName={APP_TEAM_NAME}
		id="projectCreateImportModal"
		packageName={APP_IDENTIFIER}
		fallback="unmount"
	>
		<ImportModal {...props} />
	</JSErrorBoundary>
);
